// extracted by mini-css-extract-plugin
export default {"strong":"strong__YzlmZ","serif":"serif__MzY1Y"};